import { Component } from '@angular/core';
import {
    AngularWebsiteCoreIoCKeys,
    IAngularWebsiteCoreIoCContainer,
} from 'angular-website-core-src';
import { IoCContainer } from '@lmnop/web-core';
import { IWebsiteCoreSettings } from '@lmnop/website-core';
import { BaseComponent } from '@lmnop/angular-core';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
    template: '',
    selector: 'angular-website-core-page-base',
})
export abstract class PageBase extends BaseComponent {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
        this.ioc = IoCContainer.get(
            AngularWebsiteCoreIoCKeys.IAngularWebsiteCoreIoCContainer
        );
        this.settings = this.ioc.settings;
    }

    protected ioc: IAngularWebsiteCoreIoCContainer;
    protected settings: IWebsiteCoreSettings;
}
